import CurrencyConfig from '../../components/WalletConfig/CurrencyConfig';

export default function CurrencyConfigPage() {
	return <CurrencyConfig />;
}
